<se-ap-search-filter
    (searchRequired)="handleSearchRequired()"
    (searchParamsChanged)="onParamsChanged($event)"
    [formType]="formType"
    [searchParams]="searchParams"
    [searchTypes]="searchTypes"
    [searchOnInit]="searchOnInit"
></se-ap-search-filter>

<!-- griglia aggrid dei risultati -->
<se-search-result
    (primaryChanged)="handlePrimaryChange($event)"
    (visibilityChanged)="handleVisibilityChange($event)"
    [canItemBeSelected]="fnCanItemBeSelectedHandler"
    [canPatientHistoryOpenForSelection]="fnCanPatientHistoryOpenForSelectionHandler"
    [disabledShowHideIdList]="disabledShowHideIdList"
    [formType]="formType"
    [getButtonContentForSelection]="fnGetButtonContentForSelectionHandler"
    [idPropertyName]="idPropertyName"
    [isBusy]="isBusy"
    [items]="(searchResult$ | async) ?? []"
    [rowSelection]="rowSelection"
    [showPrimaryColSetting]="true"
    class="ap-search-container-class se-flex-1"
></se-search-result>
<div class="estensa-spinner" *ngIf="isBusy">
    <mat-spinner></mat-spinner>
</div>
